import { Locale, type LocalizedString } from "../Locale.js";

export const iceCreamAnchor = {
	[Locale.cs]: "tocena-zmrzlina" as const,
} satisfies LocalizedString;
